/**
 * Query key factory. Keys are hierarchical so that invalidating a prefix refreshes everything below it:
 *   invalidate(qk.siteScope(id)) → pages, assets, collections, submissions, domains, deployments of that site.
 */
export const qk = {
  sitesAll: () => ['sites'] as const,
  sites: (workspaceId: string) => ['sites', 'list', workspaceId] as const,
  site: (siteId: string) => ['sites', 'detail', siteId] as const,

  siteScope: (siteId: string) => ['site', siteId] as const,
  pages: (siteId: string) => ['site', siteId, 'pages'] as const,
  deployments: (siteId: string) => ['site', siteId, 'deployments'] as const,
  assets: (siteId: string) => ['site', siteId, 'assets'] as const,
  collections: (siteId: string) => ['site', siteId, 'collections'] as const,
  submissionsAll: (siteId: string) => ['site', siteId, 'submissions'] as const,
  submissions: (siteId: string, query: Record<string, unknown>) => ['site', siteId, 'submissions', query] as const,
  domains: (siteId: string) => ['site', siteId, 'domains'] as const,

  itemsAll: (collectionId: string) => ['collection', collectionId, 'items'] as const,
  items: (collectionId: string, query: Record<string, unknown>) => ['collection', collectionId, 'items', query] as const,

  templates: () => ['templates'] as const,
};
